module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av365-b9aa9a2129e5615b88bed180bd351a1b.jpg";